import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import API from "../axios";
import dOffer from "../assets/awardDefault.png";
import "../style/offer.css";

const Offer = () => {

  const [offers, setOffers] =
    useState([]);

    const [showModal, setShowModal] =
  useState(false);

const [selectedImage, setSelectedImage] =
  useState("");


  const [loading, setLoading] =
    useState(false);

  // FETCH OFFERS
  const fetchOffers = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/offers"
      );

      console.log("data : ",res.data);

      setOffers(res.data);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {

    fetchOffers();

  }, []);

  // DOWNLOAD IMAGE
  const downloadImage = (
    image,
    title
  ) => {

    const link =
      document.createElement("a");

    link.href = image;

    link.download =
      `${title || "offer"}.png`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  // SHARE IMAGE
 const shareImage = async (item) => {

  try {

    const imageUrl = item.imageBase
      ? `data:image/png;base64,${item.imageBase}`
      : dOffer;

    // Convert base64 to blob
    const response = await fetch(imageUrl);

    const blob = await response.blob();

    const file = new File(
      [blob],
      `${item.title || "offer"}.png`,
      { type: blob.type }
    );

    // Mobile/native share support
    if (
      navigator.canShare &&
      navigator.canShare({ files: [file] })
    ) {

      await navigator.share({
        title: item.title,
        text: item.title,
        files: [file]
      });

    } else {

      alert("Sharing not supported on this device/browser");

    }

  } catch (err) {

    console.log("Share Error:", err);

  }
};

  return (

    <div className="offer-page pt-lg-5">

      <motion.h2
        className="offer-title"
        initial={{
          opacity: 0,
          y: -20
        }}
        animate={{
          opacity: 1,
          y: 0
        }}
      >
        Offers
      </motion.h2>

      {/* LOADER */}
      {loading && (
        <div className="offer-loader-wrap">
          <div className="offer-loader"></div>
        </div>
      )}

      {/* NO DATA */}
      {!loading &&
        offers.length === 0 && (

        <div className="no-offer-box">
          No Offers Available
        </div>
      )}

      {/* OFFER LIST */}
      <div
        className={`offer-grid ${
          offers.length === 1
            ? "single-offer"
            : ""
        }`}
      >

        {offers.map(
          (item, index) => {

            const imageSrc =
              item.imageBase
                ? `data:image/png;base64,${item.imageBase}`
                : dOffer;

            return (

              <motion.div
                className="offer-card"
                key={index}
                initial={{
                  opacity: 0,
                  scale: 0.9
                }}
                animate={{
                  opacity: 1,
                  scale: 1
                }}
                transition={{
                  duration: 0.3
                }}
              >

                {/* <img
                  src={imageSrc}
                  alt="offer"
                  className="offer-img"
                /> */}

                <img
                    src={imageSrc}
                    alt="offer"
                    className="offer-img"
                    onClick={() => {

                      setSelectedImage(imageSrc);

                      setShowModal(true);

                    }}
                  />


                <div className="offer-body">

                  <h4>
                    {item.title}
                  </h4>

                  <p>
                    {new Date(
                      item.createdDate
                    ).toLocaleDateString(
                      "en-GB"
                    )}
                  </p>

                  <div className="offer-btns">

                    <button
                      className="download-btn"
                      onClick={() =>
                        downloadImage(
                          imageSrc,
                          item.title
                        )
                      }
                    >
                      Download
                    </button>

                    <button
                      className="share-btn"
                      onClick={() =>
                        shareImage(item)
                      }
                    >
                      Share
                    </button>

                  </div>

                </div>

              </motion.div>
            );
          }
        )}

      </div>

      {/* IMAGE MODAL */}
{showModal && (

  <div
    className="offer-modal-overlay"
    onClick={() =>
      setShowModal(false)
    }
  >

    <motion.div
      className="offer-modal-box"
      initial={{
        scale: 0.8,
        opacity: 0
      }}
      animate={{
        scale: 1,
        opacity: 1
      }}
      transition={{
        duration: 0.2
      }}
      onClick={(e) =>
        e.stopPropagation()
      }
    >

      <button
        className="offer-close-btn bg-danger text-white"
        onClick={() =>
          setShowModal(false)
        }
      >
        ✕
      </button>

      <img
        src={selectedImage}
        alt="full-offer"
        className="offer-full-img"
      />

    </motion.div>

  </div>
)}


    </div>
  );
};

export default Offer;